'use client';
import styled from 'styled-components';
import getMediaQueriesStyling from '../../../features/helpers/get-media-query-styling';
export const DivContainer = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;

  ${(props) => getMediaQueriesStyling(props)}
`;
